import { render, staticRenderFns } from "./ShowModal.vue?vue&type=template&id=615207f8"
import script from "./ShowModal.vue?vue&type=script&lang=js"
export * from "./ShowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports